function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export const Search = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.29 19.29L6.69 15.9C5.59302 14.5024 4.99779 12.7767 5 11C5 6.58172 8.58172 3 13 3C17.4183 3 21 6.58172 21 11C21 15.4183 17.4183 19 13 19C11.2233 19.0022 9.49755 18.407 8.1 17.31L4.71 20.71C4.32108 21.1021 3.68792 21.1047 3.2958 20.7158C3.29386 20.7139 3.29193 20.7119 3.29 20.71V20.71C2.89788 20.3211 2.89528 19.6879 3.2842 19.2958C3.28613 19.2939 3.28806 19.2919 3.29 19.29L3.29 19.29ZM19 11V11C19 7.68629 16.3137 5 13 5C9.68629 5 7 7.68629 7 11C7 14.3137 9.68629 17 13 17C16.3137 17 19 14.3137 19 11L19 11Z",
  fill: "currentColor"
}));